var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXClose = function SvgXClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.4 19.654 4.347 18.6l6.6-6.6-6.6-6.6L5.4 4.346l6.6 6.6 6.6-6.6L19.654 5.4l-6.6 6.6 6.6 6.6-1.054 1.054-6.6-6.6z"
  })));
};
export default SvgXClose;